import React, { useEffect, useState } from "react";
import { Button, Checkbox, Form, Input, Flex, Row, Col, Image } from "antd";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import "../../Styles/login.css";
import useLogin from "../../services/hooks/useLogin";
import { forgetPassValidationSchema } from "../../validations/authValidation";
import Loader from "../../Components/Loader/Loader";
import useCustomSnackbar from "../../helper/useCustomSnackbar";
import usePost from "../../services/usePost";

const ForgetPassword = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [isLoading, error, handleForgotPassword] = useLogin("auth/forgot-password");
  const { handleSubmit, control, formState: { errors } } = useForm({
    resolver: yupResolver(forgetPassValidationSchema),
    mode: "onChange",
  });

  const showSnackbar = useCustomSnackbar()
  const [isForgetPasswordLoading, isForgetPasswordLoadingError, postData] = usePost();

  const handleRedirectLogin = () => {
    navigate('/')
  }
  useEffect(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 500);
  }, []);
  const onSubmit = async (values) => {
    // setIsLoggedIn(true);
    // navigate("/dashboard");
    // console.log("Success:", values);

    // try {
    //   await handleForgotPassword(values)
    // } catch (error) {
    //   setLoginError(error.message);
    // } finally {
    //   setLoading(false);
    // }

    const dataToSend = {
      email: values.email,
      redirectURL: "https://userpanel.taggeo.net/reset-password"
    }

    try {
      const response = await postData('auth/forgot-password', dataToSend, true, false)

      if (response?.error) {
        // console.log(response,'.....')
        showSnackbar('error', 'User not found')
      }
      else {
        showSnackbar('success', 'Password reset link has been sent to your email')
      }
    }
    catch (err) {
      console.log(err)
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Row justify="center" align="middle" gutter={16} className="form_section">
      {(isLoading || loading) && <Loader />}
      <Col md={12}>
        <div className="forgetPass"></div>
      </Col>
      <Col md={12}>
        <Form
          className="login_form"
          name="login"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={handleSubmit(onSubmit)}
        >
          <h3>Forgot your Password ?</h3>

          <hr className="my-4" />
          <Form.Item
            label={
              <span>
                Email <span style={{ color: 'red' }}>*</span>
              </span>
            } validateStatus={errors.email ? "error" : ""} help={errors.email?.message}>
            <Controller
              name="email"
              control={control}
              render={({ field }) => <Input {...field} className="input_field" placeholder="Email" />}
            />
          </Form.Item>
          <Form.Item>
            <Button
              block
              type="primary"
              htmlType="submit"
              className="btn_submit"
            >
              Reset
            </Button>
          </Form.Item>
          <Form.Item>
            <Flex justify="center" align="center">
              <p onClick={handleRedirectLogin} style={{ cursor: "pointer", color: "#4372C2", fontWeight: '500' }}>Back to Login</p>
            </Flex>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
};

export default ForgetPassword;
